import { observable } from "@mixitone/mvc";

export default abstract class BaseService<State = Record<string, never>> {
  get initialState(): State {
    return {} as State;
  }

  state: State;

  constructor() {
    this.state = observable(this.initialState as object) as State;
  }
}
